import { SocialIcons } from '../SocialIcons';

const PLATFORMS = [
  { key: 'instagram', label: 'Instagram', color: '#E1306C' },
  { key: 'facebook', label: 'Facebook', color: '#1877F2' },
  { key: 'twitter', label: 'X', color: '#ffffff' },
  { key: 'tiktok', label: 'TikTok', color: '#00f2ea' },
  { key: 'snapchat', label: 'Snapchat', color: '#FFFC00' },
  { key: 'youtube', label: 'YouTube', color: '#FF0000' },
  { key: 'spotify', label: 'Spotify', color: '#1DB954' },
  { key: 'apple_music', label: 'Apple Music', color: '#FC3C44' },
  { key: 'soundcloud', label: 'SoundCloud', color: '#FF5500' },
  { key: 'tidal', label: 'Tidal', color: '#00FFFF' },
];

export function FollowSection({ artistProfile, siteSettings, isVisible }) {
  if (!isVisible('follow')) return null;
  if (!artistProfile?.social_links || !Object.values(artistProfile.social_links).some(v => v)) return null;

  return (
    <section className="border-t border-[#262626] py-16 sm:py-24 px-4 sm:px-8" data-testid="follow-section" id="follow">
      <div className="max-w-5xl mx-auto text-center">
        <p className="overline text-[var(--primary,#FF3B30)] mb-2">STAY CONNECTED</p>
        <h2 className="font-cabinet text-3xl sm:text-4xl font-black uppercase tracking-tighter mb-12">
          {siteSettings?.section_titles?.follow || 'FOLLOW ME'}
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          {PLATFORMS.filter(p => artistProfile.social_links[p.key]).map(({ key, label, color }) => {
            const IconComponent = SocialIcons[key];
            if (!IconComponent) return null;
            return (
              <a
                key={key}
                href={artistProfile.social_links[key]}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col items-center gap-2 w-24"
                data-testid={`follow-${key}`}
              >
                <div className="w-14 h-14 border border-[#262626] flex items-center justify-center group-hover:border-[var(--primary,#FF3B30)] transition-all duration-300 group-hover:scale-110">
                  <IconComponent className="w-6 h-6 text-[#A3A3A3] group-hover:text-white transition-colors"
                    onMouseEnter={(e) => e.currentTarget.style.color = color}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#A3A3A3'}
                  />
                </div>
                <span className="text-xs text-[#A3A3A3] uppercase tracking-wide group-hover:text-white transition-colors">{label}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
